import { Component } from "react";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class SimpleErrorBoundary extends Component {
    componentDidCatch(error, info) {
        this.setState({
            hasError: true
        });
        console.error('An error has occurred while rendering the component!', error, info);
    }
    render() {
        if (this.state.hasError) return 'Error';
        return this.props.children;
    }
    constructor(...args){
        super(...args), _define_property(this, "state", {
            hasError: false
        });
    }
}
const Simple = SimpleErrorBoundary;
export default Simple;
export { SimpleErrorBoundary };
